module.exports = new __parcel__URL__("massrevitalization.eb2b849a.png").toString();